import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLearnCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2.4,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 12l5 5 9-10" })
});
export default SvgLearnCheck;
